<!-- MOBİL UYARI (Aynen Korundu) -->
<div *ngIf="!isMobile" class="mobile-warning-wrapper">
  <div class="mobile-warning-card">
    <div class="icon"><i class="fas fa-mobile-alt"></i></div>
    <h2>Mobil Cihaz Gerekli</h2>
    <p>Yoklamalar; Wi-Fi doğrulaması ve GPS tespiti için <b>yalnızca mobil cihazlardan</b> alınmaktadır.</p>
    <span class="redirect-text">3 saniye içinde yönlendirileceksiniz…</span>
  </div>
</div>

<div *ngIf="isMobile" class="syllabus-root container py-3">

  <!-- ÜST BAŞLIK & YENİLE -->
    <div class="d-flex align-items-center justify-content-between mb-4">
    <div>
      <h4 class="page-title mb-0 text-white">Ders Programı</h4>
      <small class="opacity-75 text-white">Hoş geldiniz, iyi dersler dileriz.</small>
    </div>
    <div class="d-flex gap-2">
      <a href="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/" target="_blank" class="btn btn-action-icon" title="Kullanım Kılavuzu">
        <i class="fa fa-question-circle"></i>
      </a>
      <button class="btn btn-action-icon" (click)="refreshSyllabus()">
        <i class="fa fa-sync-alt" [class.fa-spin]="isLoading"></i>
      </button>
    </div>
  </div>
  <!-- FLUTTER STYLE SCROLL TABS -->
  <ul class="nav custom-tabs mb-3 scroll-tabs">
    <li class="nav-item" *ngFor="let day of weekdays; let i = index">
      <button class="nav-link" [class.active]="selectedTab === i" (click)="selectedTab = i">
        {{ day }}
      </button>
    </li>
  </ul>

  <!-- YÜKLENİYOR -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-light" role="status"></div>
  </div>

  <!-- DERS LİSTESİ -->
  <div *ngIf="!isLoading && deviceRegistred">
    <div *ngFor="let item of filterByDay(weekdays[selectedTab])" class="modern-syllabus-card mb-3">

      <!-- ÜST KISIM: BİLGİ VE AKSİYON -->
      <div class="p-3">
        <div class="row g-2 align-items-start">

          <!-- SOL: DERS DETAYLARI -->
          <div class="col-lg-8 col-xl-8 col-md-8 col-12">
            <div class="d-flex align-items-center gap-2 mb-1">
              <span class="badge-id">#{{ item.yoklamaNo }}</span>
              <span class="lesson-date">{{ item.yoklamaTarihi }}</span>
            </div>

            <h5 class="lesson-title mb-1">{{ item.dersSube }}</h5>

            <div class="lesson-meta mb-2">
              <span *ngIf="item.grup" class="group-tag">{{ item.grup }} GRUBU</span>
              <span class="type-tag">{{ item.dersTuru || 'Normal' }}</span>
            </div>

            <div class="d-flex flex-column gap-1 info-rows">
              <div class="info-item">
                <i class="far fa-clock"></i> {{ formatTime(item.saat!) }}
              </div>
              <div class="info-item">
                <i class="fa fa-door-open"></i> {{ item.derslik || 'Derslik bilgisi yok' }}
              </div>
            </div>
          </div>

          <!-- SAĞ: BUTONLAR -->
          <div class="col-lg-4 col-xl-4 col-md-4 col-12 d-flex flex-column gap-2">


            <button *ngIf="item.attendanceInfo"
                    class="btn btn-qr w-100"
                    [ngClass]="getQrButtonClass(item)"
                    (click)="openQrPage(item)">
              <i class="bi bi-qr-code-scan"></i>
              <span>{{ yoklamaText(item) }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- ALT KISIM: PROGRESS & SLOTLAR (Senin tüm mantığın burada) -->
      <div class="card-footer-attendance p-3" *ngIf="item.attendanceInfo?.ogrenciDersSaatleri?.length">

        <!-- Yüzdelik ve Progress Bar -->
        <div class="d-flex justify-content-between align-items-end mb-2">
          <span class="progress-label">Katılım Durumu</span>
          <span class="progress-percent text-success">%{{ getAttendancePercent(item.attendanceInfo) }}</span>
        </div>

        <div class="attendance-progress-wrapper">
          <div class="attendance-progress-bar" [style.width.%]="getAttendancePercent(item.attendanceInfo)"></div>
        </div>

        <!-- Slotlar (Hem isAllTaken hem değil durumu tek döngüde) -->
        <div class="attendance-slots mt-3">
          <div *ngFor="let slot of item.attendanceInfo?.ogrenciDersSaatleri"
               class="attendance-slot"
               [ngClass]="getSlotClass(slot, item.attendanceInfo)">
            {{ slot.slotNumber }}. Saat
          </div>
        </div>
      </div>

    </div>

    <!-- BOŞ DURUM -->
    <div *ngIf="filterByDay(weekdays[selectedTab]).length === 0" class="no-data-card text-center p-5">
      <div class="empty-icon mb-3"><i class="bi bi-calendar-x"></i></div>
      <h6>Ders Programı Boş</h6>
      <p>Bugün için planlanmış bir dersiniz bulunmuyor.</p>
    </div>
  </div>
</div>
